import { observer } from 'mobx-react';
import React from 'react';

import ServiceRouter from '@common/components/ServiceRouter';

import Academy from './Academy';
import Lyceum from './Lyceum';

function AppointmentsPage() {
	return <ServiceRouter lyceum={<Lyceum />} academy={<Academy />} />;
}

export default observer(AppointmentsPage);
